import { all, takeLatest, takeEvery } from 'redux-saga/effects';
import { getCreativity } from '@gcloud-npm/next12.app-controller.reducers-sagas.custo-saga/server';
import { types as custoActions } from '@gcloud-npm/next12.app-controller.reducers-sagas.custo-reducer';
import { ACTIONS as mainActions } from '@gcloud-npm/next12.app-controller.reducers-sagas.main-reducer-n';
import { types as modalsAnchorActions } from '@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer';
import {
  initAnchorModalListener,
  addModal,
} from '@gcloud-npm/next12.app-controller.reducers-sagas.modals-saga-n';
import { getSeo } from '@gcloud-npm/next12.app-controller.reducers-sagas.main-saga';
import { types as constantsTypes } from '../reducers/constants';
import { getBusinessProps } from './constants';

function* rootSaga() {
  const SAGAS_TASKS = [
    takeLatest(mainActions.GET_CURRENT_SEO, getSeo),
    // ANCHOR MODAL
    takeLatest(modalsAnchorActions.INIT_ANCHOR_MODAL, initAnchorModalListener),
    takeLatest(modalsAnchorActions.ADD_MODAL, addModal),
    // CUSTO
    takeEvery(custoActions.GET_CREATIVITY, getCreativity),
    takeLatest(constantsTypes.GET_BUSINESS_CONSTANTS, getBusinessProps),
  ];
  

  yield all(SAGAS_TASKS);
}

export default rootSaga;

